// extracted by mini-css-extract-plugin
module.exports = {"myWaves":"style_myWaves__eNiXP"};